export const GoogleDocsIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 48 48" width="64" height="64">
    <path fill="#2196f3" d="M37 45H11a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h19l11 11v27a4 4 0 0 1-4 4" />
    <path fill="#bbdefb" d="M40 14H30V4z" />
    <path fill="#1565c0" d="M30 14h10v1l-11-1" />
    <path fill="#e3f2fd" d="M15 23h18v2H15zm0 4h18v2H15zm0 4h18v2H15zm0 4h12v2H15z" />
  </svg>
);
